import { Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import Inputs from "../../biblio/Inputs/Inputs";
import SecondaryButton from "../../biblio/Buttons/SecondaryButton";
import {
  toAddRequestBeneficiaries,
  toGetServicesBeneficiaries, 
} from "../../apis/actions/services.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import Selects from "../../biblio/Selects/Selects";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { showNotitfication } from "../utils/utils";
import { setResModel ,setResIds } from "../../apis/slices/ratingSlice";

interface servicesRequestCardProps {
  service: any;
  setSelectedService: any;
}
const ServicesRequestCard = ({
  service,
  setSelectedService,
}: servicesRequestCardProps) => {
  const [form] = Form.useForm(); 
  const dispatch = useDispatch<AppDispatch>();
  const { data: servicesBeneficiaries } = useSelector(
    (state: RootState) => state.services.servicesBeneficiaries
  );
  const [list, setList] = useState<any[]>([]);
  const [value, setValue] = useState<number>(
    service.type === "amount" ? service.amount : 1
  );
  const toAddRequestBeneficiary = async () => {
    let addRequest: any = {};
    addRequest["service_id"] = service.id;
    // eslint-disable-next-line eqeqeq
    const item = service.type == "amount" ? "amount" : "quantity";
    if (service.targeted === "family") {
      addRequest[item] = value;
    } else {
      let mappedList = list.map((el) => {
        return { partner_id: el.partner_id, [item]: el.quantity };
      });
      addRequest["line_ids"] = mappedList;
    }

    try {
      const success = (await dispatch(
        toAddRequestBeneficiaries(addRequest)
      )) as any;
      const serviceRequest = success?.payload?.data?.result;

      if (serviceRequest?.code === 200) {
        setSelectedService(null);  
        dispatch(setResModel(serviceRequest?.res_model));
        dispatch(setResIds([serviceRequest?.id]))
        showNotitfication(serviceRequest?.message, "success" ,dispatch);
      } else {
        showNotitfication(success?.payload?.data?.error.data.message, "error");
      }
    } catch (error) {
      console.error();
    }
  };

  useEffect(() => {
    dispatch(toGetServicesBeneficiaries({ service_id: service.id }));
  }, [dispatch, service]);

  useEffect(() => {
    if (servicesBeneficiaries?.length > 0) {
      setList([
        {
          quantity: service.type === "amount" ? service.amount : 1,
          partner_id: servicesBeneficiaries[0].id,
        },
      ]);
    }
  }, [service, servicesBeneficiaries, dispatch]);

  const handleInputChange = (e: any, index?: number) => {
    const inputValue = parseInt(e.target.value);
    let entredValue = 0;
    if (service.type === "amount") {
      entredValue = Math.min(inputValue, service.amount);
    } else {
      entredValue = Math.min(Math.max(inputValue, 1), service.allowed_quantity);
    }
    if (service.targeted === "family") {
      setValue(entredValue);
    } else {
      const updatedList = [...list];
      updatedList[index!!].quantity =
        list.length > 1
          ? Math.min(
              entredValue,
              list
                .filter((_, i) => i !== index)
                .reduce((a, b) => a + b.quantity, 0)
            )
          : entredValue;
      setList(updatedList);
    }
  };

  const toAdd = () => {
    setList([
      ...list,
      {
        quantity: service.type === "amount" ? service.amount : 1,
        partner_id: servicesBeneficiaries.filter(
          (item1: any) => !list.some((item2) => item2.partner_id === item1.id)
        )[0].id,
      },
    ]);
  };

  const toDelete = (index: number) => {
    setList(list.filter((_, i) => i !== index));
  };

  const getAvailableBeneficiaries = (index: number) => {
    return servicesBeneficiaries.filter(
      (item1: any) =>
        !list
          .filter((_: any, i: number) => i !== index)
          .some((item2) => item2.partner_id === item1.id)
    );
  };

  const onSelectChange = (e: any, index: number) => {
    const updatedList = [...list];
    updatedList[index].partner_id = e.value;
    setList(updatedList);
  };
  return (
    <div dir="rtl">
      <Form
        form={form}
        layout="horizontal"
        className="takaful--form-service-request"
      >
        {service.targeted === "family" && (
          <Row dir="rtl" justify={"center"} style={{ marginTop: "2rem" }}>
            <Col xxl={10} xl={10} lg={10} md={10} sm={12} xs={12}>
              <Form.Item
                label={service.type === "amount" ? "المبلغ" : "الكمية"}
                className="takaful--label-inputs"
                labelCol={{
                  className: "takaful--label-style",
                  xs: { span: 6 },
                  sm: { span: 6 },
                }}
                wrapperCol={{ xs: { span: 16 }, sm: { span: 16 } }}
                labelAlign="right"
              >
                <Inputs
                  sizeInput="middle"
                  withArrow={true}
                  className={`takaful--donation-input takaful--input-payment-with-arrows`}
                  type="number"
                  style={{
                    height: "33px",
                    padding: "0 11px 0 0",
                    marginRight: "5px",
                    fontSize: "1rem",
                  }}
                  min={1}
                  value={value}
                  disabled={service.type === "amount"}
                  onChange={handleInputChange}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        {service.targeted === "person" && (
          <Row>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <div className="takaful--table-container">
                <table className="takaful--table">
                  <thead>
                    <tr>
                      <th style={{ width: "40%" }}>المستفيد</th>
                      <th style={{ width: "25%" }}>
                        {service.type === "amount" ? "المبلغ" : "الكمية"}
                      </th>
                      <th className="takaful--table-service-button-container">
                        <PrimaryButton
                          title={""}
                          disabled={
                            list.length === servicesBeneficiaries?.length
                          }
                          icon={<PlusCircleOutlined />}
                          onClick={() => toAdd()}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((el: any, index: number) => (
                      <tr key={index}>
                        <td>
                          <Row align="middle" gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <Selects
                                disabled={index < list?.length - 1}
                                value={el.partner_id}
                                style={{
                                  width: "100%",
                                }}
                                popupMatchSelectWidth={220}
                                options={
                                  servicesBeneficiaries
                                    ? getAvailableBeneficiaries(index)
                                    : []
                                }
                                className="takaful--request-select"
                                onChange={(e) => onSelectChange(e, index)}
                              />
                            </Col>
                          </Row>
                        </td>
                        <td>
                          <Row align="middle" gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <Inputs
                                disabled={service.type === "amount"}
                                sizeInput="middle"
                                withArrow={true}
                                className="takaful--donation-input takaful--input-payment-with-arrows"
                                type="number"
                                style={{
                                  width: "100%",
                                  height: "33px",
                                  padding: "0 11px 0 0",
                                  fontSize: "1rem",
                                }}
                                min={1}
                                value={el?.quantity}
                                onChange={(e) => handleInputChange(e, index)}
                              />
                            </Col>
                          </Row>
                        </td>
                        <td>
                          <Row align="middle" justify="center" gutter={[8, 8]}>
                            {list?.length > 1 && (
                              <Col xs={24} sm={24} md={24} lg={24}>
                                <PrimaryButton
                                  title={""}
                                  icon={<DeleteOutlined />}
                                  onClick={() => toDelete(index)}
                                />
                              </Col>
                            )}
                          </Row>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        )}
      </Form>
      <SecondaryButton
        title="الترشح للخدمة"
        className="takaful--services-request-button"
        onClick={() => toAddRequestBeneficiary()}
      />
      <Row dir="rtl" style={{ marginTop: "1rem" }}>
        <Col
          xxl={24}
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ textAlign: "center" }}
        >
          <span className="takaful--services-request-span">
            سيتم مراعات الاولوية عند اعتماد الترشحات وفق
          </span>
          <p className="takaful--services-request-p">
            سياسة الخدمات في الجمعية
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default ServicesRequestCard;
